// @flow
import React, { Component, type ComponentType } from "react";
import Spinner from "@atlaskit/spinner";
import InfiniteScroll from "react-infinite-scroller";

import { Spacer, LoadingBlogs } from "./styled";

type Props = {|
    blogs: ComponentType<any>,
    BlogCard: ComponentType<any>
|};

type State = {
    maxRowsToDisplay: boolean
};

class BlogCardListView extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            maxRowsToDisplay: 5
        };
    }

    showMore() {
        this.setState({
            maxRowsToDisplay: this.state.maxRowsToDisplay + 5
        });
    }

    render() {
        const { blogs, BlogCard } = this.props;

        if (blogs === null) {
            return (
                <LoadingBlogs>
                    <Spinner key="blogs-spinner" size="medium" />
                </LoadingBlogs>
            );
        } else if (blogs.length > 0) {
            const displayedBlogs = [];
            for (let i = 0; i < blogs.length && i < this.state.maxRowsToDisplay; i += 1) {
                const { id } = blogs[i];
                displayedBlogs.push(<Spacer key={`spacer${id}`} />);
                displayedBlogs.push(<BlogCard key={`blog-card${id}`} blog={blogs[i]} />);
            }

            if (blogs.length > 0) {
                displayedBlogs.push(<Spacer key="spacer" />);
            }

            return (
                <InfiniteScroll
                    pageStart={0}
                    loadMore={() =>
                        this.setState({ maxRowsToDisplay: this.state.maxRowsToDisplay + 5 })
                    }
                    hasMore={this.state.maxRowsToDisplay < blogs.length}
                    loader={
                        <div className="loader" key={0}>
                            Loading ...
                        </div>
                    }
                >
                    {displayedBlogs}
                </InfiniteScroll>
            );
        }

        return null;
    }
}

export default BlogCardListView;



// WEBPACK FOOTER //
// ./src/home-page-view/blog-card-list/view.js